module.exports = __webpack_public_path__ + "img/investor_mexc@2x.43477391.png";